import { render, staticRenderFns } from "./examReportPDF.vue?vue&type=template&id=ed5d46b0&scoped=true&"
import script from "./examReportPDF.vue?vue&type=script&lang=js&"
export * from "./examReportPDF.vue?vue&type=script&lang=js&"
import style0 from "./examReportPDF.vue?vue&type=style&index=0&id=ed5d46b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5d46b0",
  null
  
)

export default component.exports